<template>
  <div style="height: 100%;">
    <!--设备统计-->
    <el-row style="margin-left: 15%;">
      <el-col :span="18" style="border-bottom: 1px solid rgba(1, 239, 253, .2);margin-top: 10px;">
        <el-col :span="11" style="margin-top: 6px;">安防设备:</el-col>
        <el-col :span="6" style="font-size: 1.6rem;margin-top: -4px;color: rgba(0, 196, 211, 1);">24</el-col>
        <el-col :span="7" class="tagPic"></el-col>
      </el-col>
    </el-row>
    <el-row style="margin-left: 15%;">
      <el-col :span="18" style="border-bottom: 1px solid rgba(1, 239, 253, .2);margin-top: 10px;">
        <el-col :span="11" style="margin-top: 6px;">动力设备:</el-col>
        <el-col :span="6" style="font-size: 1.6rem;margin-top: -4px;color: rgba(0, 196, 211, 1);">24</el-col>
        <el-col :span="7" class="tagPic"></el-col>
      </el-col>
    </el-row>
  </div>

</template>

<script>
export default {
  name: "DeviceStatistic"
}
</script>

<style scoped>

</style>